import { Attribute, Directive, forwardRef } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
  standalone: false,
  selector: '[minNumber][formControlName],[minNumber][formControl],[minNumber][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => MinNumberValidatorDirective), multi: true }
  ]
})
export class MinNumberValidatorDirective implements Validator {
  constructor(@Attribute('minNumber') public minNumber: string) {
  }

  validate(control: AbstractControl): { [key: string]: any } {
    // self value (e.g. retype password)
    let value = +control.value;

    // control value (e.g. password)
    let minNumber = +this.minNumber;

    // value not equal
    if (value != null && value != undefined && value < minNumber) {
      return {
        validateEqual: false
      };
    }

    return null;
  }
}
